import React from "react";

export default function LinkedInConversionPixel() {
  return (
    <img
      height="1"
      width="1"
      style={{ display: "none" }}
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=3049148&conversionId=3920532&fmt=gif"
    />
  );
}
